import { createStore } from 'redux'
import rootReducer from './reducers'
import { defaultState } from './utils/consts'

let initialState = {}

const store = createStore(rootReducer, defaultState)
export default store
